// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.szBET{align-items:center}.szBET .KXNlv{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"includedServiceRow": `szBET`,
	"includedServiceItem": `KXNlv`
};
export default ___CSS_LOADER_EXPORT___;
